/**
 * 組織選擇 Hook
 * 管理選中的組織，根據用戶資訊自動設定預設組織
 */

import { useState, useCallback, useEffect } from 'react';
import { getDefaultOrg, ORG_LIST } from '../services/userService';

export const useOrgSelection = (userData) => {
  const [selectedOrg, setSelectedOrg] = useState("KS"); // Default to KS

  // 確保 selectedOrg 有初始值
  useEffect(() => {
    if (!selectedOrg) {
      setSelectedOrg('KS');
    }
  }, [selectedOrg]);

  /**
   * 根據用戶資訊設定預設組織
   */
  const setDefaultOrgFromUser = useCallback((userData) => {
    const defaultOrg = getDefaultOrg(userData);
    if (defaultOrg) {
      setSelectedOrg(defaultOrg);
    }
  }, []);

  // 當 userData 改變時，自動設定預設組織
  useEffect(() => {
    if (userData) {
      setDefaultOrgFromUser(userData);
    }
  }, [userData, setDefaultOrgFromUser]);

  return {
    selectedOrg,
    setSelectedOrg,
    setDefaultOrgFromUser,
    orgList: ORG_LIST,
  };
};

